"use client";
import { format } from "date-fns";
import Link from "next/link";
import { useRef } from "react";
import { BlogPost } from "../../../../../blogposts";
import { OptimizedImage } from "../../../../components/OptimizedImage";
import { Tags } from "./Tags";

export function Article({ blogPost }: { blogPost: BlogPost }) {
  const postDate = format(blogPost.date, "MMM do, yyyy");
  const desktopLinkRef = useRef<HTMLAnchorElement>(null);

  return (
    <>
      <style jsx global>{`
        .expand-anchor::after {
          content: "";
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
        }
      `}</style>
      <>
        <div className="hidden md:block">
          <div className="relative flex items-center px-4 py-2 space-x-6 bg-white rounded-md shadow-lg cursor-pointer hover:bg-gray-100">
            <div className="ml-2 -mb-1">
              <OptimizedImage
                src={blogPost.heroImage}
                height={82}
                width={82}
                alt={blogPost.title}
                className="object-cover border-r border-gray-400 rounded-md"
              />
            </div>
            <div className="w-full py-4 -mt-2">
              <Link href={`/writing/${blogPost.slug}`} passHref legacyBehavior>
                <a ref={desktopLinkRef} className="text-xl expand-anchor">
                  {blogPost.title}
                </a>
              </Link>
              <div className="text-sm font-semibold text-gray-700 max-width[80ch]">
                {blogPost.description}
              </div>
              <div className="flex flex-col justify-between mt-2 space-y-2 lg:items-center md:flex-row md:space-y-0">
                <div className="text-sm text-gray-700 uppercase">
                  {postDate}
                </div>
                <div className="relative">
                  <Tags tags={blogPost.tags} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      <>
        <div className="block space-y-8 md:hidden">
          <Link href={`/writing/${blogPost.slug}`} passHref legacyBehavior>
            <a>
              <div className="bg-white card-shadow">
                <div className="flex">
                  <div className="">
                    <OptimizedImage
                      src={blogPost.heroImage}
                      height={98}
                      width={98}
                      alt={blogPost.title}
                      className="object-cover"
                    />
                  </div>
                  <div className="flex flex-col justify-between pt-2 pb-2 pl-4 pr-4 leading-5">
                    <div className="font-bold">{blogPost.title}</div>
                    <div className="text-sm text-gray-700 uppercase">
                      {postDate}
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </Link>
        </div>
      </>
    </>
  );
}
